import request from "../request";

/**
 * Состояние корзины
 * @return {Promise}
 */
export const count = () => {
  return request({
    url: "/cart/count",
    type: "GET",
    needOverlay: false,
  });
};